import React from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function VerifyEmail() {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg mx-auto px-4 py-16 text-center">
      <div className="card-soft p-10">
        <CheckCircle2 className="mx-auto text-emerald-500 mb-4" size={48} />
        <h1 className="text-2xl font-extrabold">All set</h1>
        <p className="text-gray-600 mt-2">
          You can sign in and start booking. If you need to reset your password, use the "Forgot password?" link on the sign-in page.
        </p>
        <button
          onClick={() => navigate("/sign-in")}
          className="pill-btn primary mt-5"
          style={{ padding: "0.75rem 1.6rem" }}
        >
          Continue to sign in
        </button>
      </div>
    </div>
  );
}
